import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { NotFoundError } from 'src/shared/error';

import type { LocalDataQuery, LocalDataQueryVariables } from './api.graphql';
import { LocalData } from './api.graphql';

export type LocalPageData = NonNullable<LocalDataQuery['localPageLocation']>;

export async function getLocalPageData(
	{ gql: { fetch } }: UtilityContext,
	slug: string,
): Promise<LocalPageData & { location?: { lat: number; lng: number } }> {
	// TODO (CHANGE-76577): replace with actual location type
	const { data } = await fetch<LocalDataQuery, LocalDataQueryVariables>({
		query: LocalData,
		variables: {
			slug,
		},
		rejectOnError: true,
	});

	if (!data.localPageLocation) {
		// this is so the page can handle the error in the ErrorHandler
		throw new NotFoundError();
		// alternatively, we could throw another error (like NotFoundError),
		// which would be instead handled by ErrorBoundary
	}

	return data.localPageLocation;
}
